var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.452,
    height: 21,
    viewBox: "0 0 21.452 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_alert_in_box",
    "data-name": "icona alert in box",
    transform: "translate(-550.775 -102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_alert_in_box-2",
    "data-name": "icona alert in box",
    transform: "translate(549.172 99.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_355",
    "data-name": "Tracciato 355",
    d: "M10.691,5.267,2.584,18.8a1.914,1.914,0,0,0,1.637,2.871H20.435A1.914,1.914,0,0,0,22.071,18.8L13.965,5.267a1.914,1.914,0,0,0-3.273,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_356",
    "data-name": "Tracciato 356",
    d: "M18,13.5v3.828",
    transform: "translate(-5.672 -3.313)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_357",
    "data-name": "Tracciato 357",
    d: "M18,25.5h0",
    transform: "translate(-5.672 -7.656)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_784",
    "data-name": "Rettangolo 784",
    transform: "translate(551 102)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInBox);
export default __webpack_public_path__ + "static/media/alert_in_box.e0af97a7be0086ca2e657e937a59ed93.svg";
export { ForwardRef as ReactComponent };